import React, { useMemo } from 'react'
import { useQuery } from '@apollo/client'
import Box from '@material-ui/core/Box'
import { DateTime } from 'luxon'
import SectionTitle from 'components/section-title'
import WeeklyRevenueCard from './weekly-revenue-card'
import BookingMixCard from './booking-mix-card'
import {
  GET_GROWTH_BOOKING_MIX_SCHEDULE,
  GET_GROWTH_REGISTRATION_PAYMENTS,
} from './query'
import { buildBookingMixFromSchedule, buildWeeklyRevenueSeries } from './utils'
import { WEEKLY_REVENUE_WEEKS } from './constants'
import useStyles from './styles'

const GrowthPerformance = () => {
  const classes = useStyles()

  const revenueRange = useMemo(() => {
    const end = DateTime.local().endOf('week')
    const start = end.minus({ weeks: WEEKLY_REVENUE_WEEKS - 1 }).startOf('week')

    return {
      from: start.toISO(),
      to: end.toISO(),
    }
  }, [])

  const bookingMixRange = useMemo(() => {
    const start = DateTime.local().startOf('month')
    const end = DateTime.local().endOf('month')

    return {
      from: start.toISO(),
      to: end.toISO(),
    }
  }, [])

  const {
    data: revenueData,
    loading: revenueLoading,
    error: revenueError,
  } = useQuery(GET_GROWTH_REGISTRATION_PAYMENTS, {
    variables: { createdAt: revenueRange },
  })

  const {
    data: scheduleData,
    loading: scheduleLoading,
    error: scheduleError,
  } = useQuery(GET_GROWTH_BOOKING_MIX_SCHEDULE, {
    variables: {
      startDateTime: bookingMixRange,
      orderBy: [{ field: 'START_DATE_TIME', direction: 'ASC' }],
    },
  })

  const weeklyRevenueSeries = useMemo(
    () => buildWeeklyRevenueSeries(revenueData?.registrationPayments || []),
    [revenueData?.registrationPayments],
  )

  const bookingMix = useMemo(
    () =>
      buildBookingMixFromSchedule(scheduleData?.currentUser?.schedule || []),
    [scheduleData?.currentUser?.schedule],
  )

  const isRevenueLoading = revenueLoading && !revenueData
  const isScheduleLoading = scheduleLoading && !scheduleData

  return (
    <Box className={classes.section}>
      <SectionTitle size="large" className={classes.sectionTitle}>
        Growth &amp; performance
      </SectionTitle>
      <Box className={classes.grid}>
        <WeeklyRevenueCard
          series={weeklyRevenueSeries}
          loading={isRevenueLoading}
          error={revenueError}
        />
        <BookingMixCard
          bookingMix={bookingMix}
          loading={isScheduleLoading}
          error={scheduleError}
        />
      </Box>
    </Box>
  )
}

export default GrowthPerformance
